module.exports = __webpack_public_path__ + "media/src/images/abouts/bg_image/about_pattern-ad8ec991ae461e22e66165c66beb3a45.png";